export type ViewMode = 'grid' | 'list';

export function parseView(value: string | null | undefined): ViewMode {
  if (value === 'list') return 'list';
  return 'grid';
}
